// import React, { useEffect, useState } from 'react';
// import './index.scss';
// import DetailInnerSidebar from '../DetailInnerSidebar';
// import DetailsModule from '../../../../dca-modules/crud/Details';
// import { useParams } from 'react-router-dom';
// import { get } from '../../../../utils/api';
// import RightSideCommonComponent from '../RightSideCommonComponent';

// interface SidebarItem {
//   key: string; // Unique key for each sidebar item
//   label: string; // Label to display
//   component: React.ComponentType<any>; // The component to render for this item
// }

// interface SubSidebarProps {
//   items: SidebarItem[]; // Array of sidebar items
//   defaultItemKey: string; // The key of the default item to display
//   module: any; // Your module prop
//   primary_key: any; // Your primary key prop
// }

// const DetailSubsiderView: React.FC<SubSidebarProps> = ({
//   items,
//   defaultItemKey,
//   module,
//   primary_key,
// }) => {
//   const { id } = useParams();

//   const [selectedItemKey, setSelectedItemKey] = useState<string>(defaultItemKey);
//   const [formData, setFormData] = useState<any>({});

//   useEffect(() => {
//     getData();
//   }, [module]);

//   const getData = async () => {
//     let params = { [primary_key]: id };
//     try {
//       const response = await get(`${module}/details`, params);
//       setFormData(response.data); // Set the detailed form data
//     } catch (error) {
//       console.log("Error fetching data: ", error);
//     }
//   };
//   const renderComponent = () => {
//     const selectedItem = items.find(item => item.key === selectedItemKey) || items.find(item => item.key === defaultItemKey);
//     const SelectedComponent = selectedItem?.component;
//     let values: any;
//     if (formData) {
//       console.log("nn", formData[selectedItemKey])
//       values = formData[selectedItemKey]
//     }
//     console.log("selectedcom", SelectedComponent, selectedItemKey, values)
//     // Check if the selected item key is "general" and render accordingly
//     if (selectedItemKey === 'general' && SelectedComponent) {

//       return <DetailsModule module={module} primary_key={primary_key} />;
//     } else if (SelectedComponent && selectedItemKey != 'general') {
//       console.log("selectedItemKey", selectedItemKey)
//       return <RightSideCommonComponent
//         module={module}
//         primary_key={primary_key}
//         key={selectedItemKey}
//         values={Array.isArray(values) ? values : [values]} // Ensure values is an array or a single item
//       />;
//     } else {
//       // Fallback to DetailsModule if no selected component is found
//       // return <DetailsModule module={module} primary_key={primary_key} />;
//     }
//   };

//   return (
//     <div className="app-container">
//       <DetailInnerSidebar items={items} onSelect={setSelectedItemKey} />
//       <div className="right-side-content">{renderComponent()}</div>
//     </div>
//   );
// };

// export default DetailSubsiderView;



import React, { useEffect, useState } from 'react';
import './index.scss';
import DetailInnerSidebar from '../DetailInnerSidebar';
import DetailsModule from '../../../../dca-modules/crud/Details';
import { useParams } from 'react-router-dom';
import { get } from '../../../../utils/api';
import RightSideCommonComponent from '../RightSideCommonComponent';

interface SidebarItem {
  key: string; // Unique key for each sidebar item
  label: string; // Label to display
  component: React.ComponentType<any>; // The component to render for this item
}

interface SubSidebarProps {
  items: SidebarItem[]; // Array of sidebar items
  defaultItemKey: string; // The key of the default item to display
  module: any; // Your module prop
  primary_key: any; // Your primary key prop
}

const DetailSubsiderView: React.FC<SubSidebarProps> = ({
  items,
  defaultItemKey,
  module,
  primary_key,
}) => {
  const { id } = useParams();
  const [selectedItemKey, setSelectedItemKey] = useState<string>(defaultItemKey);
  const [formData, setFormData] = useState<any>({});

  useEffect(() => {
    getData();
  }, [module]);

  const getData = async () => {
    let params = { [primary_key]: id };
    try {
      const response = await get(`${module}/details`, params);
      setFormData(response.data); // Set the detailed form data
    } catch (error) {
      console.log("Error fetching data: ", error);
    }
  };

  const renderComponent = () => {
    const selectedItem:any = items.find(item => item.key === selectedItemKey) || items.find(item => item.key === defaultItemKey);
    const SelectedComponent = selectedItem?.component;
    let values: any;

    if (formData) {
      // Get values based on selectedItemKey
      values = formData[selectedItemKey];
    }

    // Check if the selected item key is "general" and render accordingly
    if (selectedItemKey === 'general' && SelectedComponent) {
      return <DetailsModule module={module} primary_key={primary_key} />;
    } else if (SelectedComponent && selectedItemKey !== 'general') {
      console.log("selectedItemKey", selectedItemKey)
      let key_name:any=selectedItem.values;
      let field_name:any=selectedItem.key;
      console.log(selectedItem)
      return (
        <RightSideCommonComponent
          module={module}
          field_name={field_name}
          key_name={key_name}
          values={Array.isArray(values) ? values : [values]} // Ensure values is an array or a single item
          primary_key={primary_key}
        />
      );
    } else {
      // Fallback to DetailsModule if no selected component is found
      // return <DetailsModule module={module} primary_key={primary_key} />;
    }
  };

  return (
    <div className="app-container">
      <DetailInnerSidebar items={items} onSelect={setSelectedItemKey} />
      <div className="right-side-content">{renderComponent()}</div>
    </div>
  );
};

export default DetailSubsiderView;
